<template>
	<div>
		<h1 class="title">Créer un CIL</h1>
		<div class="card white">
			<h2>Détails du logement</h2>
			<div class="form-group">
				<div class="form-control">
					<label for="name">Nom du logement</label>
					<input type="text" id="name" v-model="property.name" required />
				</div>
				<div class="form-control type">
					<label for="register-email">Type</label>
					<select id="type" v-model="property.typ" required>
						<option value="0">Appartement</option>
						<option value="1">Maison</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<div class="form-control address">
					<label class="info-label" for="address">Adresse</label>
					<input type="text" id="address" v-model="searchAddress" @input="searchAddresses" autocomplete="off"
						required />
					<div v-if="searchAddress.length > 0" class="info-message">Sélectionnez une adresse dans la liste des
						propositions.</div>
					<ul v-if="addressOptions.length" class="address-options">
						<li v-for="option in addressOptions" :key="option" @click="selectAddress(option)">{{
							option.label }}</li>
					</ul>
				</div>
				<div class="form-control fiscal">
					<label for="fiscal_number">Numéro fiscal</label>
					<input type="text" id="fiscal_number" v-model="property.fiscal_number" />
				</div>
			</div>

			<h2>Fichiers du logement</h2>

			<div class="uploaded-files">
				<div v-for="(files, type) in groupedFiles" :key="type">
					<h3>{{ type }}</h3>
					<div v-for="file in files" :key="file.name" class="file-entry">
						<i v-if="file.name.toLowerCase().endsWith('.pdf')" class="bi bi-file-pdf-fill"></i>
						<i v-else class="bi bi-file-image-fill"></i>
						<p class="file-name">{{ file.name }}</p>
						<p class="file-action" @click="openPreview(file)">Voir</p>
						<p>|</p>
						<p class="file-action" @click="deleteFile(file)">Supprimer</p>
					</div>
				</div>
			</div>
			<div v-if="!dpeFilesExist || !auditFilesExist" class="form-control" style="flex-direction: row;">
				<label v-if="!dpeFilesExist" for="dpe" class="button outline dotted normal">Ajouter un DPE</label>
				<input type="file" name="dpe" id="dpe" class="hidden-input" multiple @change="handleDPEUpload" />
				<label v-if="!auditFilesExist" for="audit" class="button outline dotted normal">Ajouter un audit
					énergétique</label>
				<input type="file" name="audit" id="audit" class="hidden-input" multiple @change="handleAuditUpload" />
			</div>
			<div class="form-control">
				<button class="button outline normal" @click="openUploadFile">Ajouter d'autres diagnostics</button>
			</div>

			<h2>Propriétaire du logement</h2>
			<div class="form-group">
				<div class="form-control">
					<label for="email">Email</label>
					<input type="text" id="email" v-model="email" required />
				</div>
			</div>
			<input type="hidden" v-model="property.id_ban" name="id_ban" />
			<input type="hidden" v-model="property.lat" name="lat" />
			<input type="hidden" v-model="property.lng" name="lng" />
			<div v-if="errorMessage" class="message">{{ errorMessage }}</div>
			<button type="submit" class="button fill normal" @click="submitForm" :disabled="isSubmitting">Créer le
				CIL</button>
		</div>
		<FichierSelectPopup :isVisible="showUploadFile" title="Ajouter un fichier" @confirm1="handleFileUpload"
			@cancel1="closeUploadFile">
		</FichierSelectPopup>
	</div>
</template>

<script>
import FichierSelectPopup from "@/franchise-pages/FichierSelectPopup.vue";

export default {
	name: "AjouterCIL",
	components: {
		FichierSelectPopup,
	},
	data() {
		return {
			email: "",
			property: {
				name: "Propriété Principale",
				typ: "0",
				id_ban: "",
				lat: "",
				lng: "",
				fiscal_number: "",
			},
			showUploadFile: false,
			searchAddress: "",
			addressOptions: [],
			errorMessage: "",
			uploadedFiles: [],
			isSubmitting: false,
		};
	},
	methods: {
		async searchAddresses() {
			if (this.searchAddress.length < 3) return;
			try {
				const response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${this.searchAddress}&limit=5`);
				const data = await response.json();
				this.addressOptions = data.features.map((feature) => {
					return {
						id: feature.properties.id,
						geometry: feature.geometry,
						label: feature.properties.label,
					};
				});
			} catch (error) {
				console.error("Erreur lors de la recherche d'adresse:", error);
			}
		},
		selectAddress(option) {
			this.property.id_ban = option.id;
			this.property.lat = option.geometry.coordinates[1];
			this.property.lng = option.geometry.coordinates[0];
			this.searchAddress = option.label;
			this.addressOptions = [];
		},
		async submitForm() {
			if (!this.property.id_ban || !this.property.lat || !this.property.lng) return this.errorMessage = "Veuillez sélectionner une adresse valide dans les propositions.";

			try {
				this.isSubmitting = true;
				this.errorMessage = "";

				const formData = new FormData();
				formData.append("name", this.property.name);
				formData.append("typ", this.property.typ);
				formData.append("id_ban", this.property.id_ban);
				formData.append("lat", this.property.lat);
				formData.append("lng", this.property.lng);
				formData.append("fiscal_number", this.property.fiscal_number);
				formData.append("email", this.email);

				this.uploadedFiles.forEach((file) => formData.append(file.selectedType, file.blob, file.name));

				const response = await fetch(process.env.VUE_APP_API_URL + "franchise/add", { method: "POST", credentials: "include", body: formData, });

				if (response.ok) {
					this.errorMessage = "";
					this.$router.push(`/franchise`);
				} else {
					const errorData = await response.json();
					this.errorMessage = errorData.message || "Erreur lors de la soumission des données. Veuillez réessayer.";
				}
				this.isSubmitting = false;
			} catch (error) {
				console.error("Erreur lors de la soumission du formulaire:", error);
				this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
			} finally {
				this.isSubmitting = false;
			}
		},
		checkUploadFile(type) {
			return ["image/jpeg", "image/png", "application/pdf"].includes(type);
		},
		handleDPEUpload(event) {
			this.addFilesWithType(event.target.files, "DPE");
		},
		handleAuditUpload(event) {
			this.addFilesWithType(event.target.files, "Audit énergétique");
		},
		addFilesWithType(files, type) {
			const validFiles = Array.from(files).filter((file) => this.checkUploadFile(file.type));
			const uploadFiles = validFiles.map((file) => ({
				name: file.name,
				size: file.size,
				type: file.type,
				blob: file,
				selectedType: type,
			}));
			this.uploadedFiles = this.uploadedFiles.concat(uploadFiles);
		},
		handleFileUpload(files) {
			console.log(files);
			this.uploadedFiles = this.uploadedFiles.concat(files);
			this.showUploadFile = false;
		},
		openUploadFile() {
			this.showUploadFile = true;
		},
		closeUploadFile() {
			this.showUploadFile = false;
		},
		openPreview(file) {
			if (!file) return;
			if (file.type.startsWith("image/")) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const image = new Image();
					image.src = e.target.result;
					const previewWindow = window.open("", "_blank");
					previewWindow.document.write(image.outerHTML);
				};
				reader.readAsDataURL(file.blob);
			} else if (file.type === "application/pdf") {
				const pdfUrl = URL.createObjectURL(file.blob);
				const previewWindow = window.open(pdfUrl, "_blank");
				previewWindow.document.title = file.name;
			} else {
				this.errorMessage = "Seuls les fichiers JPEG, PNG et PDF sont autorisés.";
			}

		},
		deleteFile(file) {
			this.uploadedFiles = this.uploadedFiles.filter((f) => f !== file);
		},
	},
	computed: {
		groupedFiles() {
			const grouped = {};
			this.uploadedFiles.forEach((file) => {
				if (!grouped[file.selectedType]) {
					grouped[file.selectedType] = [];
				}
				grouped[file.selectedType].push(file);
			});
			return grouped;
		},
		dpeFilesExist() {
			return this.uploadedFiles.some((file) => file.selectedType === "DPE");
		},
		auditFilesExist() {
			return this.uploadedFiles.some((file) => file.selectedType === "Audit énergétique");
		},
	},
};
</script>

<style scoped>
.form-control.type,
.form-control.fiscal {
	flex: 0.5;
}

.form-control.address {
	position: relative;
}

.uploaded-files {
	margin-bottom: 25px;
}

.uploaded-files>div:not(:first-child) {
	margin-top: 10px;
}

.hidden-input {
	width: 1px;
	height: 1px;
	padding: 0;
	opacity: 0;
}
</style>
